import { RestrictionFeature } from "../../../../types";

export const getRestrictionVariation = (
  data: RestrictionFeature.RestrictionBarData,
  restrictionContext: "Staff" | "Patron"
): RestrictionFeature.RestrictionVariation => {
  if (data.willViolate) {
    if (
      (restrictionContext === "Staff" && data.rule.staffOverride === "NONE") ||
      (restrictionContext === "Patron" && data.rule.memberOverride === "NONE")
    ) {
      return "error";
    } else if (
      (restrictionContext === "Staff" && data.rule.staffOverride === "WARN") ||
      (restrictionContext === "Patron" && data.rule.memberOverride === "WARN")
    ) {
      return "warning";
    }
  } else {
    return "info";
  }

  return "info";
};
